import { useEffect, useRef, useState } from "react";
import { fetchLocaleInfo } from "@repo/shopify/src/utils/locale";

const SERVER_TIME = "SERVER_TIME";
const LOCAL_TIME = "LOCAL_TIME";

export default function useServerTime() {
  const [serverTime, setServerTime] = useState(new Date());

  const serverTimeRef = useRef<number>(-1);

  const getServerTime = async () => {
    const localeInfo = await fetchLocaleInfo();

    // fetchLocaleInfo의 결과가 undefined이면 로컬 시간 사용
    if (!localeInfo) {
      const now = new Date();
      serverTimeRef.current = now.getTime();
      setServerTime(new Date(serverTimeRef.current));
    } else {
      const now = new Date(localeInfo.server_time);
      serverTimeRef.current = now.getTime();
      sessionStorage.setItem(SERVER_TIME, JSON.stringify(now.getTime()));
      sessionStorage.setItem(LOCAL_TIME, JSON.stringify(new Date().getTime()));
      setServerTime(new Date(serverTimeRef.current));
    }
  };

  useEffect(() => {
    void getServerTime();

    const sessionServerTime = sessionStorage.getItem(SERVER_TIME);
    const sessionLocalTime = sessionStorage.getItem(LOCAL_TIME);

    if (sessionServerTime) {
      // API 호출 최소화
      // 서버 시간을 불러온 시점의 로컬 시간이랑 현재 로컬 시간이랑 계산해서 현재 시간 추출
      const timeGap = new Date().getTime() - Number(sessionLocalTime);
      const now = new Date(Number(sessionServerTime) + timeGap);
      serverTimeRef.current = now.getTime();
      setServerTime(new Date(serverTimeRef.current));
    } else {
      void getServerTime();
    }
  }, []);

  return serverTime;
}
